@if (visible) {
  <div class="test-site-banner" role="alert">
    <span class="test-site-banner-icon" aria-hidden="true">⚠</span>
    <span class="test-site-banner-text">
      This is the <strong>{{ envLabel }}</strong> test environment — not for
      production use.
    </span>
    <button
      type="button"
      class="test-site-banner-close"
      (click)="dismiss()"
      aria-label="Dismiss"
    >
      ×
    </button>
  </div>
}
